'use client';

import { useEffect, useState } from 'react';
import { usePaginator } from './PaginatorContext';

export default function PaginatorItem({ index = null, hasNext = false, className = '', children = null }) {
  const [isActive, setIsActive] = useState(false);
  const paginator = usePaginator();
  useEffect(() => {
    setIsActive(index === paginator.index);
  }, [paginator.index]);

  const handleClick = () => {
    if (hasNext) {
      paginator.setNextIndex(index);
    } else if (index !== null) {
      paginator.setIndex(index);
    }
  };
  return (
    <div onClick={handleClick} className={`Paginator__item ${isActive ? 'Paginator__item--active' : ''} ${className}`}>
      {children && children}
    </div>
  );
}
